// AD-8 · Professional Passport · Public View — locked copy mirror (r2).
// Frontend mirror of backend/domain/ad8_public_registry.py.
// A doctrine test asserts wording equality. Do not edit without
// a paired backend change.

export const AD8_REGISTRY_VERSION      = "ad8.v1";
export const AD8_ORCHESTRATION_VERSION = "ad8_v1.0";

// r2 amendment A — 180-day rolling freshness window (private constant).
export const AD8_FRESHNESS_WINDOW_DAYS = 180;

// r2 §6 · §8 · amendments H and I — locked wording.
export const AD8_PAGE_TITLE             = "Professional Passport";
export const AD8_CURRENT_PRACTICE_LABEL = "Current practice";
export const AD8_EMPTY_STATE_LINE       =
  "Current professional practice statements are not available at this time.";
export const AD8_FOOTER_LINE =
  "Controlled by the instructor. Statements reflect recent " +
  "professional practice evidence recorded through NDG.";

// r2 §7.1 · display-name sanitisation constants (client-side hint;
// authoritative validation is server-side).
export const AD8_DISPLAY_NAME_MAX_LENGTH = 80;

// Instructor-facing button labels (kept minimal — the settings
// page is not part of the operator-locked public contract but
// exposes the four AD-8 endpoints).
export const AD8_SETTINGS_LABELS = {
  visibilityOn:       "Make my public passport visible",
  visibilityOff:      "Hide my public passport",
  displayNameLabel:   "Public display name",
  displayNameSave:    "Save display name",
  displayNameClear:   "Clear display name",
  rotateSlug:         "Rotate public link",
  publicUrlHeader:    "Your public passport link",
};
